import { useUser } from "./../useUser";
import SmallHeaderCard from "@/components/SmallHeaderCard";
import AdminLineItem from "@/components/AdminLineItem";
import typo from "@/styles/Typography.module.css";
import { NavLink } from "react-router-dom";

export default function PlatformConfigurationManager() {
  const user = useUser();
  console.log("Platform Configuration Manager user:", user);

  return (
    <div>
     <AdminLineItem title="Platform Configuration Management" user={user}>
          <div className="mb-4">
            <h1 style={{color: "#F16D09", paddingBottom: "2.5rem", marginTop: "3rem"}}>Platform Configuration Management</h1>
          </div>
       {/* Monitoring section */}
               <div className="row g-1">
      <div>
          <div style={{ paddingTop: ".5rem", marginTop: "2rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
PLATFORM CONFIGURATION TOOLS            </p>
          </div>
        </div>
                <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
                 <NavLink
                             to="/admin/configuration/fileUpload"
                             className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                             style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
                           >
                            Document uploads - upload pdf's, images and other resources for platform users to access
                           </NavLink> 
                   </div>

                    <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
                 <NavLink
                             to="/admin/configuration/emailTemplatesPage"
                             className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                             style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
                           >
                            Manage email templates - view and edit email templates used for user communications, e.g. registration, password reset etc
                           </NavLink> 
                   </div>
              </div>
            
        </AdminLineItem>
    </div>
    );
};
